console.log("Tabletop Goodies - Script - Loggers");

TTG = function (parent) {
    const result = {};

    result.Level =
    {
        Critical: 0,
        Error: 1,
        Warning: 2,
        Information: 3,
        Debug: 4,
        Trace: 5,
        None: 6
    }


    result.logWarning = function (message, data) {
        if (data === undefined) {
            console.warn("TTG: " + message);
        }
        else {
            console.warn("TTG: " + message, data);
        }
    }

    result.logError = function (message, data) {
        if (data === undefined) {
            console.error(message);
        }
        else {
            console.error(message, data);
        }
    }

    result.logInformation = function (message, data) {
        if (data === undefined) {
            console.log("TTG: " + message);
        }
        else {
            console.log("TTG: " + message, data);
        }
    }

    result.logDebug = function (message, data) {
        if (data === undefined) {
            console.debug("TTG: " + message);
        }
        else {
            console.debug("TTG: " + message, data);
        }
    }


    parent.Loggers = result;
    return parent;
}(TTG);


